import React, { useState, useContext, useRef, useEffect } from 'react';
import { ThemeContext } from '../context/ThemeContext';
import '../styles/chat.css';

const ChatInput = ({ onSubmit, isLoading }) => {
  const [input, setInput] = useState('');
  const { isDarkMode } = useContext(ThemeContext);
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      const scrollHeight = textareaRef.current.scrollHeight;
      const maxHeight = window.innerHeight / 3;
      textareaRef.current.style.height = `${Math.min(scrollHeight, maxHeight)}px`;
    }
  }, [input]);

  const handleSubmit = () => {
    if (input.trim().length >= 3 && !isLoading) {
      onSubmit(input);
      setInput('');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <div className={`chat-input-container ${isDarkMode ? 'dark' : 'light'}`}>
      <textarea
        ref={textareaRef}
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Type your message..."
        className={isDarkMode ? 'dark' : 'light'}
        disabled={isLoading}
      />
      <button 
        onClick={handleSubmit}
        disabled={input.trim().length < 3 || isLoading}
        className={`send-button ${isDarkMode ? 'dark' : 'light'}`}
      >
        ↑
      </button>
    </div>
  );
};

export default ChatInput; 